
import Swal from 'sweetalert2'
import {
    IS_LOADING_LOGIN_PASSWORD,
    NOT_LOADING_LOGIN_PASSWORD,
    LOGIN_SOCIAL_USER
} from './types'
import { urlServer } from '../config/GlobalConstant'
import inMemoryJWT from '../auth/inMemoryJwt';
import socketLogic from '../sockets/sockets';
import localStorage from '../utils/hooks/useLocalStorage';
const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
})

export const sendSocialUser = (registerSocialUser, history) => async dispatch => {

    dispatch({
        type: IS_LOADING_LOGIN_PASSWORD
    });

    // console.log()
    await fetch(`${urlServer}static-routes/google-register`, {
        withCredentials: true,
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            registerSocialUser
        ) // body data type must match "Content-Type" header      
    })
        .then(response => response.json())
        .then(respJson => {

            dispatch({
                type: NOT_LOADING_LOGIN_PASSWORD
            });

            if (!respJson.success) throw respJson;

            console.log();
            const errorType = respJson.error;

            if (!respJson.data.isAcceptTerms) {
                localStorage().setItem("externalLogin", "google")
                history.push({
                    pathname: '/AceptTerms', state: {
                        id: respJson.data._id
                    }
                })
            } else {
                if (respJson.data.token) {
                    inMemoryJWT.setToken(respJson.data.token.token, respJson.data.token.expirationTimeToken)
                    const accessToken = inMemoryJWT.getToken()

                }
                if (respJson.data.type === "user") {
                    {
                        localStorage().setItem("externalLogin", "google")
                        localStorage().setItem("typeProfile", "user")
                        localStorage().setItem("nameUser", respJson.data.name)
                        localStorage().setItem("lastNameUser", respJson.data.lastname)


                        localStorage().setItem("idProfile", respJson.data._id)

                        localStorage().setItem("idUser", respJson.data._id)
                        let picture;
                        if (respJson.data.picture) {
                            picture = respJson.data.picture.url ? respJson.data.picture.url.small ? respJson.data.picture.url.small : respJson.data.picture.url.origin : respJson.data.picture;

                        } else {
                            picture = ""

                        }
                        localStorage().setItem("picturProfile", picture)
                        localStorage().setItem("typeUser", respJson.data.type)

                        socketLogic.userConnect(localStorage().getItem('idProfile'))

                    }
                }


                if (respJson.success === true && respJson.error === null && respJson.data.type === "user") {
                    //history.replace ('/')   
                    localStorage().setItem("statusLog", true);
                    history.go(0)

                } else if (respJson.success === true && respJson.data.type === "admin") {
                    localStorage().setItem("idUser", respJson.data._id)
                    localStorage().setItem("statusLog", true);
                    history.push('/admin')
                } else if (respJson.success === true && respJson.data.type === "warehouse") {
                    localStorage().setItem("typeProfile", "user")
                    localStorage().setItem("typeUser", "user")
                    localStorage().setItem("idUser", respJson.data._id)
                    localStorage().setItem("idUser", respJson.data._id)
                    localStorage().setItem("statusLog", true);
                    history.push('/inventory')
                }

                dispatch({
                    type: LOGIN_SOCIAL_USER,
                    payload: {
                        errorType,
                        registerSocialUser: respJson.data
                    }
                });

            }

        })
        .catch(error => {
            console.log();
            Toast.fire({
                icon: "error",
                title: "Error vuelve a intentarlo"
            });
        })
}

export const sendSocialUserFacebook = (registerSocialUser, history) => async dispatch => {
    console.log()
    await fetch(`${urlServer}static-routes/facebook-register`, {
        withCredentials: true,
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            registerSocialUser
        ) // body data type must match "Content-Type" header      
    })
        .then(response => response.json())
        .then(respJson => {
            if (!respJson.data.isAcceptTerms) {
                localStorage().setItem("externalLogin", "facebook")
                history.push({
                    pathname: '/AceptTerms', state: {
                        id: respJson.data._id
                    }
                })
            } else {
                if (respJson.data.token) {
                    inMemoryJWT.setToken(respJson.data.token.token, respJson.data.token.expirationTimeToken)
                    const accessToken = inMemoryJWT.getToken()

                }
                if (respJson.data.type === "user") {
                    {
                        localStorage().setItem("externalLogin", "facebook")
                        localStorage().setItem("typeProfile", "user")
                        localStorage().setItem("nameUser", respJson.data.name)
                        localStorage().setItem("lastNameUser", respJson.data.lastname)


                        localStorage().setItem("idProfile", respJson.data._id)

                        localStorage().setItem("idUser", respJson.data._id)
                        let picture;
                        if (respJson.data.picture) {
                            picture = respJson.data.picture.url ? respJson.data.picture.url.small ? respJson.data.picture.url.small : respJson.data.picture.url.origin : respJson.data.picture;

                        } else {
                            picture = ""

                        }
                        localStorage().setItem("picturProfile", picture)
                        localStorage().setItem("typeUser", respJson.data.type)

                        socketLogic.userConnect(localStorage().getItem('idProfile'))

                    }
                }


                if (respJson.success === true && respJson.error === null && respJson.data.type === "user") {
                    //history.replace ('/')   
                    localStorage().setItem("statusLog", true);
                    history.go(0)

                } else if (respJson.success === true && respJson.data.type === "admin") {
                    localStorage().setItem("idUser", respJson.data._id)
                    localStorage().setItem("statusLog", true);
                    history.push('/admin')
                } else if (respJson.success === true && respJson.data.type === "warehouse") {
                    localStorage().setItem("typeProfile", "user")
                    localStorage().setItem("typeUser", "user")
                    localStorage().setItem("idUser", respJson.data._id)
                    localStorage().setItem("idUser", respJson.data._id)
                    localStorage().setItem("statusLog", true);
                    history.push('/inventory')
                }
            }

        })
        .catch(error => {
            console.log()
        })
}

export const acepTerms = (phone, id, history, gender, birthDate, referralCode) => async dispatch => {
    await fetch(`${urlServer}static-routes/accept-terms`, {
        withCredentials: true,
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                id: id,
                phone: phone,
                gender,
                birthDate,
                isAcceptTerms: true,
                referralCode
            }
        ) // body data type must match "Content-Type" header      
    })
        .then(response => response.json())
        .then(respJson => {
            inMemoryJWT.setToken(respJson.data.token.token, respJson.data.token.expirationTimeToken)
            if (respJson.data.type === "user") {

                localStorage().setItem("nameUser", respJson.data.name)
                localStorage().setItem("lastNameUser", respJson.data.lastname)
                localStorage().setItem("idUser", respJson.data._id)
                localStorage().setItem("idProfile", respJson.data._id)

                let picture;
                if (respJson.data.picture) {
                    picture = respJson.data.picture.url ? respJson.data.picture.url.small ? respJson.data.picture.url.small : respJson.data.picture.url.origin : respJson.data.picture;

                } else {
                    picture = ""

                }
                localStorage().setItem("picturProfile", picture)
                localStorage().setItem("typeUser", respJson.data.type)
                localStorage().setItem("statusLog", true);
                history.go(0)
                //    socketLogic.checkStatus()
             

            }

        })
        .catch(error => {
            console.log()
        })
}
